import { Box, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

interface QueryInputProps {
  name: string;
  placeholder: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  className?: string;
  error?: string;
}

export function QueryInput(props: QueryInputProps) {
  const { name, placeholder, value, onChange, className, error } = props;

  const [initialValue, setInitialValue] = useState<string>(value);
  const [hasFocused, setHasFocused] = useState<boolean>(false);

  useEffect(() => {
    if (!hasFocused) {
      setInitialValue(value);
    }
  }, [value, hasFocused]);

  return (
    <Box className="h-full">
      <TextField
        type="text"
        name={name}
        placeholder={placeholder}
        value={value}
        className={className}
        onChange={onChange}
        error={!!error}
        helperText={error}
        onFocus={(event) => {
          setHasFocused(true);
          const currentValue = event.target.value;

          if (currentValue === initialValue) {
            event.target.select();
          }
        }}
        FormHelperTextProps={{
          sx: { textTransform: "initial" },
        }}
        size="small"
        sx={{
          width: "100%",
          height: "100%",
          background: "transparent",
          "& .MuiOutlinedInput-root": {
            height: "100%",
            border: "none",
            borderRadius: 0,
            padding: 0,
            "& input": {
              padding: 0,
              paddingX: "0.5rem",
              fontSize: "32px",
              fontWeight: 500,
              color: "black",
            },
            "&:hover fieldset": {
              borderColor: "transparent",
            },
            "&.Mui-focused fieldset": {
              borderColor: "transparent",
            },
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "transparent",
          },
          // These are mainly used in COUNT mode
          "&.fade-out .MuiInputBase-input::placeholder": {
            opacity: 0,
            transition: "opacity 0.3s ease",
          },
          "&.fade-in .MuiInputBase-input::placeholder": {
            opacity: 0.42,
            transition: "opacity 0.3s ease",
          },
          "& .MuiFormHelperText-root": {
            marginLeft: 0,
          },
        }}
        inputProps={{
          style: {
            fontSize: "32px",
            lineHeight: "38.4px",
            fontWeight: 500,
            color: "black",
            backgroundColor: "white",
          },
        }}
      />
    </Box>
  );
}
